import { STATE_KEYS } from './state';

const GETTER_TYPES = {
  GET_ITEMS: 'getItems',
  GET_ITEM_BY_ID: 'getItemById',
  GET_DATA_STATE: 'getDataState',
};

const getters = {
  [GETTER_TYPES.GET_ITEMS](state) {
    return state[STATE_KEYS.ITEMS];
  },
  [GETTER_TYPES.GET_ITEM_BY_ID](state) {
    return id => state[STATE_KEYS.ITEMS][id];
  },
  [GETTER_TYPES.GET_DATA_STATE](state) {
    return state[STATE_KEYS.DATA_STATE];
  },
};

export {
  getters,
  GETTER_TYPES,
};
